import { render, staticRenderFns } from "./printbirthcertificate.vue?vue&type=template&id=3659b434"
import script from "./printbirthcertificate.vue?vue&type=script&lang=js"
export * from "./printbirthcertificate.vue?vue&type=script&lang=js"
import style0 from "./printbirthcertificate.vue?vue&type=style&index=0&id=3659b434&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports